import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { MoveLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
// import Button from '../Shared/Button';
import 'swiper/css/grid';
import { useQuery } from '@tanstack/react-query';
import { GetAllInstructors } from '../../api/Instructor/GetAllInstructors';
import Spinner from '../Shared/Spinner';


const Instructors = () => {
    const { data: InstructorDTO, isLoading } = useQuery({
        queryFn: GetAllInstructors,
        queryKey: ["instructors"],
        staleTime: 0,
        refetchInterval: 0,
    });

    const instructors = InstructorDTO?.data || []

    return (
        <div className='sm:pb-16 pb-12'>
            <div className="relative z-50 sm:space-y-5 space-y-2.5 text-center sm:pt-20 pt-12">
                <h1 className="font-semibold text-secondary sm:text-base text-sm">Instructors</h1>
                <h2 className="md:text-4xl sm:text-3xl text-2xl font-semibold text-textPrimary mx-auto">Meet our specialized mentors!</h2>
                <p className="max-w-[764px] mx-auto sm:text-base text-sm">
                    Our philosophy is simple — hire a team of diverse, passionate people and foster a culture that empowers you to do you best work.                </p>
            </div>

            <div className="relative z-50 container px-2.5 mt-16">
                {isLoading ? (<div className='min-h-[50vh] flex justify-center items-center'>
                    <Spinner />
                </div>) : (
                    <Swiper
                        grabCursor={true}
                        navigation={{
                            nextEl: ".custom-next6",
                            prevEl: ".custom-prev6",
                        }}
                        loop={true}
                        slidesPerView={4}
                        spaceBetween={30}
                        autoplay={{
                            delay: 500,
                            disableOnInteraction: false,
                        }}
                        modules={[Autoplay, Navigation]}
                        speed={3000}
                        className="mySwiper"
                        breakpoints={{
                            0: {
                                slidesPerView: 1.1,
                                spaceBetween: 10,
                            },
                            450: {
                                slidesPerView: 1.3,
                                spaceBetween: 10,
                            },
                            550: {
                                slidesPerView: 1.6,
                                spaceBetween: 10,

                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 12,

                            },
                            768: {
                                slidesPerView: 2.5,
                                spaceBetween: 20,

                            },
                            1024: {
                                slidesPerView: 4,
                                spaceBetween: 25,
                            },
                        }}
                    >
                        {instructors.map(slide => (
                            <SwiperSlide key={slide.id} className="relative">
                                <div className="relative">
                                    <Link to={`/instructor/${slide.id}`}>
                                        <img src={slide.photo} className="md:h-[320px] h-[270px] w-full relative object-fit" alt="" />
                                    </Link>
                                    <div className="bg-white flex flex-col justify-end items-center text-center">
                                        <Link className='sm:text-xl text-lg text-primary sm:pt-5 pt-3  sm:pb-1.5 pb-1 font-bold hover:text-secondary transition-all duration-300' to={`/instructor/${slide.id}`}>Dr.{slide.firstName} {slide.lastName}</Link>
                                        <span className='font-medium sm:pb-4 pb-2.5 text-secondary sm:text-base text-sm'>{slide.university}</span>
                                        {/* <Button variant='transparent' size='sm' className='w-full !text-[#f9b001] hover:!text-white !border-[#f9b001]'>Schedule a Session</Button> */}
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
                <div className="flex justify-center mx-auto sm:gap-5 gap-2.5 items-center mt-7 w-full ">
                    <button className="custom-prev6 hover:bg-secondary transition-all duration-300 bg-white border border-secondary text-white flex items-center justify-center sm:size-[55px] size-12 rounded-full group">
                        <MoveLeft className="text-secondary group-hover:text-white sm:w-8 w-6" size={32} />
                    </button>
                    <div>
                        <div className="custom-pagination2"></div>
                    </div>
                    <button className="custom-next6 hover:bg-secondary transition-all duration-300 bg-white border border-secondary text-white flex items-center justify-center sm:size-[55px] size-12 rounded-full group">
                        <MoveLeft className="rotate-180 text-secondary group-hover:text-white sm:w-8 w-6" size={32} />
                    </button>
                </div>
            </div>

        </div>
    )
}

export default Instructors